import http from '../utils/http'

export default {
    get(data = {}) {
        return http.get('/admin/transactions', data)
    },

}
